import React from "react";
import { Box, Typography } from "@mui/material";
const MainLabel = (props) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        variant={`${props.variant}`}
        gutterBottom
        sx={{ display: "block", color: "grey.500" }}
      >
        {`${props.content}`}
      </Typography>
    </Box>
  );
};

export default MainLabel;
